import appConfig from '@/common/appConfig';

export const isAutotestEnvironment = (): boolean => appConfig.app_env
  ? ['testcafe', 'playwright'].includes(appConfig.app_env)
  : false;
